import { Dispatch, SetStateAction, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { TSplitType } from '../../models'

import styles from './SplitPlanningSwitcher.module.scss'

export interface IProps {
  splitType: TSplitType
  setSplitType: Dispatch<SetStateAction<TSplitType>>
  className?: string
  isVisible?: boolean
  isDistributorPlanner?: boolean
}

export const SplitPlanningSwitcher = ({
  splitType,
  setSplitType,
  className,
  isVisible = true,
  isDistributorPlanner,
}: IProps) => {
  /** -------------------- Methods ----------------------- */

  const getSplitTypeKey = useCallback(
    (splitType: TSplitType) => {
      let splitTypeKey: string = splitType

      if (isDistributorPlanner) {
        switch (splitType) {
          case 'Contractual':
            splitTypeKey = 'NonPower'
            break
          case 'Transactional':
            splitTypeKey = 'Power'
            break
          default:
            break
        }
      }

      return `jbp-planning-split-${splitTypeKey}`.toLocaleLowerCase()
    },
    [isDistributorPlanner]
  )

  /** -------------------- Render methods ----------------------- */

  const renderContractual = () => {
    return (
      <Button
        className={styles.button}
        variant={splitType !== 'Contractual' ? 'text' : 'contained'}
        onClick={() => {
          setSplitType('Contractual')
        }}
      >
        <Translation text={getSplitTypeKey('Contractual')} />
      </Button>
    )
  }

  const renderTransactional = () => {
    return (
      <Button
        className={styles.button}
        variant={splitType !== 'Transactional' ? 'text' : 'contained'}
        margin={'md'}
        onClick={() => {
          setSplitType('Transactional')
        }}
      >
        <Translation text={getSplitTypeKey('Transactional')} />
      </Button>
    )
  }

  /** -------------------- Render ----------------------- */

  return (
    <div className={className || styles.root}>
      {isVisible && (
        <>
          <Button
            className={styles.button}
            variant={splitType !== 'Total' ? 'text' : 'contained'}
            margin={'md'}
            onClick={() => {
              setSplitType('Total')
            }}
          >
            <Translation text={getSplitTypeKey('Total')} />
          </Button>
          {renderContractual()}
          {renderTransactional()}
        </>
      )}
    </div>
  )
}
